import { Microfrontend } from '@cian/mf-react';

import { type FC, useEffect, useState } from 'react';
import { debounce } from 'throttle-debounce';

import { FILTERS_MICROFRONTEND_ALIAS } from '@/app/shared/constants/microfrontendAliases';
import { useAlias } from '@/app/shared/context/AliasesContext';

import { ELEMENTS_IDS } from '@/packages/hybrid-search-page-layout';

import styles from './Filters.css';

const RESIZE_DEBOUNCE_DELAY = 100;

export const Filters: FC = () => {
  const [style, setStyle] = useState({});
  const manifest = useAlias(FILTERS_MICROFRONTEND_ALIAS);

  useEffect(() => {
    if (!manifest) {
      return;
    }

    const headerElement = window.document.getElementById('header-frontend');
    if (!headerElement) {
      return;
    }

    const updateFiltersPosition = (): void => {
      setStyle(prevState => ({
        ...prevState,
        top: window.getComputedStyle(headerElement).height,
      }));
    };

    const resizeHandler = debounce(RESIZE_DEBOUNCE_DELAY, updateFiltersPosition);

    updateFiltersPosition();

    window.addEventListener('resize', resizeHandler, { passive: true });

    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  if (!manifest) {
    return null;
  }

  return (
    <div className={styles['container']} id={ELEMENTS_IDS.filtersId} style={style}>
      <Microfrontend {...manifest} />
    </div>
  );
};
